export * from './ErrorPopup';
export * from './Popup';

// Controleer de definitie van PopupAction
type PopupAction = {
  actionText: string; // Het lijkt erop dat de property 'actionText' heet, niet 'text'
  onClick: () => void;
};
